var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntraverseLogoLettering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lettering",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2905 531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-6);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 812.98,
    y1: 138.16,
    x2: 1118.87,
    y2: 409.06,
    gradientTransform: "translate(0 532) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0153f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd42ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2017.09,
    y1: 138.16,
    x2: 2322.97,
    y2: 409.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 463.83,
    y1: 167,
    x2: 769.05,
    y2: 432.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1438.02,
    y1: 205.89,
    x2: 1699.35,
    y2: 350.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1693.31,
    y1: 157.85,
    x2: 1991.61,
    y2: 388.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1112.99,
    y1: 101.51,
    x2: 1582.1,
    y2: 420.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 155.49,
    y1: 134,
    x2: 462.45,
    y2: 415.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 129.28,
    y1: 192.78,
    x2: 255.39,
    y2: 235.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -26.48,
    y1: 251.98,
    x2: 109.62,
    y2: 283.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2322.7,
    y1: 147.3,
    x2: 2633.93,
    y2: 397.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 2629.59,
    y1: 170.06,
    x2: 2927.72,
    y2: 400.37,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Intraverse_Pink-2",
    "data-name": "Intraverse Pink"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1028.96,323.67c20.97-9.11,37.16-22.37,48.58-39.79,11.42-17.42,17.13-38.32,17.12-62.69,0-24.06-5.71-44.88-17.12-62.46-11.41-17.58-27.6-31.08-48.58-40.48-20.98-9.41-45.96-14.11-74.95-14.11h-140.19v323.87h75.41v-90.68h68.07l62.86,90.72h80.5l-72.16-104.1.45-.27ZM1001.66,179.78c11.72,9.72,17.58,23.52,17.58,41.41s-5.86,31.77-17.58,41.64c-11.72,9.88-29,14.81-51.82,14.81h-60.61v-112.43h60.61c22.83,0,40.1,4.84,51.82,14.53v.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2233.06,323.67c20.98-9.11,37.17-22.37,48.58-39.79,11.42-17.42,17.12-38.32,17.12-62.69s-5.7-44.88-17.12-62.46c-11.41-17.58-27.6-31.08-48.58-40.48-20.98-9.4-45.96-14.1-74.95-14.11h-140.19v323.87h75.42v-90.68h68.08l62.85,90.72h80.51l-72.17-104.1.45-.27ZM2205.77,179.78c11.72,9.72,17.58,23.52,17.58,41.41s-5.86,31.77-17.58,41.64c-11.73,9.86-29,14.8-51.82,14.81h-60.61v-112.43h60.61c22.82,0,40.1,4.85,51.82,14.54v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M489.03,164.36h103.64v262.8h74.95V164.36h103.64v-61.07h-282.23v61.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1655.18,103.29h-74.5l-105.07,236.05,39.21,87.81h.17l140.19-323.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1783.1,292.06h150.37v-58.76h-150.37v-69.86h170.26v-60.15h-244.75v323.87h250.77v-60.15h-176.28v-74.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1208.48,0l125.5,300.85h-100.37l24.96-60.03-34.58-83.11-80.09,180.27,37.11,89.18h.07l28.87-69.4h147.77l72.04,172.7h74.41L1282.98,0h-74.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M374.75,103.29v196.48L213.74,103.29h-62v36.67l82.68,101.27,152.36,185.93h62V103.29h-74.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M151.74,210.62v216.53h74.03v-125.85l-74.03-90.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,103.29h75.41v323.53L0,334.65V103.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2565.45,263.62c-11.52-6.83-23.79-12.34-36.55-16.42-13.22-4.31-26.65-7.94-40.25-10.87-13.58-2.94-25.92-5.87-37.01-8.79-11.1-2.92-20.04-7.01-26.84-12.26-3.25-2.39-5.87-5.53-7.64-9.16-1.78-3.63-2.65-7.63-2.53-11.66-.04-6.69,2.16-13.21,6.24-18.51,4.16-5.55,10.72-9.95,19.66-13.19,8.95-3.24,20.82-4.86,35.63-4.86,15.02.11,29.95,2.22,44.42,6.25,9.87,2.69,19.5,6.18,28.79,10.43l39.49-48.26c-14.77-9.19-32.05-16.25-51.86-21.16-19.75-4.92-40.03-7.41-60.38-7.4-30.53,0-55.9,4.55-76.11,13.65-20.2,9.1-35.24,21.28-45.11,36.55-9.81,15.06-14.96,32.69-14.8,50.66,0,16.96,3.31,31.07,9.95,42.33,6.54,11.18,15.76,20.56,26.83,27.3,11.59,7.09,24.02,12.69,37.01,16.66,13.42,4.16,26.76,7.71,40.02,10.64,13.27,2.93,25.53,6.01,36.79,9.25,11.25,3.24,20.27,7.4,27.06,12.49,3.26,2.33,5.89,5.43,7.66,9.02,1.78,3.59,2.64,7.56,2.52,11.57.09,6.53-2.21,12.87-6.48,17.81-4.32,5.09-11.03,9.18-20.12,12.26-9.09,3.08-21.05,4.63-35.86,4.63-19.66-.04-39.19-3.24-57.83-9.49-13.16-4.35-25.01-9.54-35.53-15.57l-38.85,47.48-.11.24c14.49,11.1,33.69,20.13,57.6,27.07,24.29,6.99,49.45,10.5,74.72,10.41,30.54,0,55.98-4.63,76.34-13.88,20.36-9.25,35.55-21.44,45.57-36.55,9.92-14.77,15.16-32.18,15.04-49.97,0-16.66-3.47-30.61-10.41-41.87-6.69-11.02-15.99-20.23-27.07-26.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2728.77,292.06v74.95h175.71l-49.21,60.15h-200.98V103.29h244.74v60.15h-170.26v69.86h150.37v58.76h-150.37Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntraverseLogoLettering);
export default __webpack_public_path__ + "static/media/Intraverse_Logo_Lettering.aad966126a34e03c7cf298be5a039091.svg";
export { ForwardRef as ReactComponent };